var $fpZC2$axios = require("axios");
var $fpZC2$fs = require("fs");
var $fpZC2$https = require("https");
var $fpZC2$jsyaml = require("js-yaml");
var $fpZC2$os = require("os");
var $fpZC2$path = require("path");
var $fpZC2$bech32 = require("bech32");
var $fpZC2$chiabls = require("chia-bls");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $c9adbe13b5bef015$exports = {};

$parcel$export($c9adbe13b5bef015$exports, "Client", () => $c9adbe13b5bef015$export$1f2bb630327ac4b6);






class $c9adbe13b5bef015$export$1f2bb630327ac4b6 {
    port = null;
    get baseUrl() {
        if (!this.port) throw new Error("Port is not set.");
        return `https://${this.host}:${this.port}`;
    }
    constructor(options = (0, ($parcel$interopDefault($fpZC2$path))).resolve((0, $fpZC2$os.homedir)(), ".chia", "mainnet")){
        if (typeof options === "string") {
            const rootPath = (0, ($parcel$interopDefault($fpZC2$path))).resolve(options);
            this.config = (0, ($parcel$interopDefault($fpZC2$jsyaml))).load((0, ($parcel$interopDefault($fpZC2$fs))).readFileSync((0, ($parcel$interopDefault($fpZC2$path))).join(rootPath, "config", "config.yaml"), "utf-8"));
            this.options = null;
            this.keyPath = (0, ($parcel$interopDefault($fpZC2$path))).join(options, this.config.daemon_ssl.private_key);
            this.certPath = (0, ($parcel$interopDefault($fpZC2$path))).join(options, this.config.daemon_ssl.private_crt);
            this.caCertPath = (0, ($parcel$interopDefault($fpZC2$path))).join(options, this.config.private_ssl_ca.crt);
            this.host = this.config.self_hostname;
        } else {
            this.config = null;
            this.options = options;
            this.keyPath = options.keyPath;
            this.certPath = options.certPath;
            this.caCertPath = options.caCertPath;
            this.host = options.host;
        }
        this.agent = new (0, $fpZC2$https.Agent)({
            ...this.caCertPath ? {
                ca: (0, ($parcel$interopDefault($fpZC2$fs))).readFileSync(this.caCertPath)
            } : {},
            cert: (0, ($parcel$interopDefault($fpZC2$fs))).readFileSync(this.certPath),
            key: (0, ($parcel$interopDefault($fpZC2$fs))).readFileSync(this.keyPath),
            rejectUnauthorized: false
        });
    }
    async request(route, body = {}) {
        return (await (0, ($parcel$interopDefault($fpZC2$axios))).post(`${this.baseUrl}/${route}`, body, {
            httpsAgent: this.agent
        })).data;
    }
}


var $d77b8e2ece17819c$exports = {};

$parcel$export($d77b8e2ece17819c$exports, "FullNode", () => $d77b8e2ece17819c$export$149ee79a7b75f142);

class $d77b8e2ece17819c$export$149ee79a7b75f142 extends (0, $c9adbe13b5bef015$export$1f2bb630327ac4b6) {
    constructor(options){
        super(options);
        this.port = typeof options === "string" ? this.config.full_node.rpc_port : options.port;
    }
    /**
     * @deprecated For backwards compatibility.
     */ async getInitialFreezePeriod() {
        return await this.request("get_initial_freeze_period");
    }
    async getBlockchainState() {
        return await this.request("get_blockchain_state");
    }
    async getBlockCountMetrics() {
        return await this.request("get_block_count_metrics");
    }
    async getNetworkInfo() {
        return await this.request("get_network_info");
    }
    async getRecentSignagePoint(spHash) {
        return await this.request("get_recent_signage_point_or_eos", {
            sp_hash: spHash
        });
    }
    async getRecentEos(challengeHash) {
        return await this.request("get_recent_signage_point_or_eos", {
            challenge_hash: challengeHash
        });
    }
    async getBlock(headerHash) {
        return await this.request("get_block", {
            header_hash: headerHash
        });
    }
    async getBlocks(startHeight, endHeight, excludeHeaderHash) {
        return await this.request("get_blocks", {
            start: startHeight,
            end: endHeight,
            exclude_header_hash: excludeHeaderHash
        });
    }
    async getBlockRecords(startHeight, endHeight) {
        return await this.request("get_block_records", {
            start: startHeight,
            end: endHeight
        });
    }
    async getBlockRecordByHeight(height) {
        return await this.request("get_block_record_by_height", {
            height: height
        });
    }
    async getBlockRecord(headerHash) {
        return await this.request("get_block_record", {
            header_hash: headerHash
        });
    }
    async getBlockSpends(headerHash) {
        return await this.request("get_block_spends", {
            header_hash: headerHash
        });
    }
    async getUnfinishedBlockHeaders() {
        return await this.request("get_unfinished_block_headers");
    }
    async getNetworkSpace(newerBlockHeaderHash, olderBlockHeaderHash) {
        return await this.request("get_network_space", {
            newer_block_header_hash: newerBlockHeaderHash,
            older_block_header_hash: olderBlockHeaderHash
        });
    }
    async getCoinRecordsByPuzzleHash(puzzleHash, startHeight, endHeight, includeSpentCoins) {
        return await this.request("get_coin_records_by_puzzle_hash", {
            puzzle_hash: puzzleHash,
            start_height: startHeight,
            end_height: endHeight,
            include_spent_coins: includeSpentCoins
        });
    }
    async getCoinRecordsByPuzzleHashes(puzzleHashes, startHeight, endHeight, includeSpentCoins) {
        return await this.request("get_coin_records_by_puzzle_hashes", {
            puzzle_hashes: puzzleHashes,
            start_height: startHeight,
            end_height: endHeight,
            include_spent_coins: includeSpentCoins
        });
    }
    async getCoinRecordsByHint(hint, startHeight, endHeight, includeSpentCoins) {
        return await this.request("get_coin_records_by_hint", {
            hint: hint,
            start_height: startHeight,
            end_height: endHeight,
            include_spent_coins: includeSpentCoins
        });
    }
    async getCoinRecordByName(name) {
        return await this.request("get_coin_record_by_name", {
            name: name
        });
    }
    async getCoinRecordsByNames(names, startHeight, endHeight, includeSpentCoins) {
        return await this.request("get_coin_records_by_names", {
            names: names,
            start_height: startHeight,
            end_height: endHeight,
            include_spent_coins: includeSpentCoins
        });
    }
    async getCoinRecordsByParentIds(parentIds, startHeight, endHeight, includeSpentCoins) {
        return await this.request("get_coin_records_by_parent_ids", {
            parent_ids: parentIds,
            start_height: startHeight,
            end_height: endHeight,
            include_spent_coins: includeSpentCoins
        });
    }
    async pushTx(spendBundle) {
        return await this.request("push_tx", {
            spend_bundle: spendBundle
        });
    }
    async getPuzzleAndSolution(coinId, height) {
        return await this.request("get_puzzle_and_solution", {
            coin_id: coinId,
            height: height
        });
    }
    async getAdditionsAndRemovals(headerHash) {
        return await this.request("get_additions_and_removals", {
            header_hash: headerHash
        });
    }
    async getAllMempoolTxIds() {
        return await this.request("get_all_mempool_tx_ids");
    }
    async getMempoolItemByTxId(txId) {
        return await this.request("get_mempool_item_by_tx_id", {
            tx_id: txId
        });
    }
    async getRoutes() {
        return await this.request("get_routes");
    }
    async healthz() {
        return await this.request("healthz");
    }
}


var $fa39ccbcfd7ae7f1$exports = {};


var $670be6b4b89f768f$exports = {};


var $0173ec613b431074$exports = {};


var $043f1599d0393806$exports = {};


var $10a2a174d127c160$exports = {};


var $7234297413ebee48$exports = {};


var $cf11edfd5f0d971f$exports = {};


var $fe571803aa61466c$exports = {};

$parcel$export($fe571803aa61466c$exports, "ConditionOpcode", () => $fe571803aa61466c$export$ca3a6889d1d58c7d);
let $fe571803aa61466c$export$ca3a6889d1d58c7d;
(function(ConditionOpcode) {
    ConditionOpcode["AGG_SIG_UNSAFE"] = "0x31";
    ConditionOpcode["AGG_SIG_ME"] = "0x32";
    ConditionOpcode["CREATE_COIN"] = "0x33";
    ConditionOpcode["RESERVE_FEE"] = "0x34";
    ConditionOpcode["CREATE_COIN_ANNOUNCEMENT"] = "0x3c";
    ConditionOpcode["ASSERT_COIN_ANNOUNCEMENT"] = "0x3d";
    ConditionOpcode["CREATE_PUZZLE_ANNOUNCEMENT"] = "0x3e";
    ConditionOpcode["ASSERT_PUZZLE_ANNOUNCEMENT"] = "0x3f";
    ConditionOpcode["ASSERT_MY_COIN_ID"] = "0x46";
    ConditionOpcode["ASSERT_MY_PARENT_ID"] = "0x47";
    ConditionOpcode["ASSERT_MY_PUZZLEHASH"] = "0x48";
    ConditionOpcode["ASSERT_MY_AMOUNT"] = "0x49";
    ConditionOpcode["ASSERT_SECONDS_RELATIVE"] = "0x50";
    ConditionOpcode["ASSERT_SECONDS_ABSOLUTE"] = "0x51";
    ConditionOpcode["ASSERT_HEIGHT_RELATIVE"] = "0x52";
    ConditionOpcode["ASSERT_HEIGHT_ABSOLUTE"] = "0x53";
})($fe571803aa61466c$export$ca3a6889d1d58c7d || ($fe571803aa61466c$export$ca3a6889d1d58c7d = {}));


var $0a03bf2c86be8e1b$exports = {};


var $46d22c3d3d92ed29$exports = {};


var $ece4b6568aa7b803$exports = {};


var $d538b0dfcf012fe0$exports = {};


var $bb68f84c05a621e3$exports = {};


var $cb49cf0709c98c68$exports = {};


var $305d95833dd1d023$exports = {};


var $1268525a4b8e0e01$exports = {};


var $358edc65b317bb37$exports = {};


var $7e2e4bcdef253857$exports = {};


var $cbe256e5a99e5fe6$exports = {};


var $cb6b976e0ac661c2$exports = {};


var $7e170c62514a6894$exports = {};


var $638e6605c9cc86e1$exports = {};


var $5deed032471b2015$exports = {};


var $bf325bebb99236c7$exports = {};


var $933d7bb5ea47325a$exports = {};


var $aa1ce64064cb849d$exports = {};


var $2bca65a862d6af26$exports = {};


var $b32038b15901be82$exports = {};


var $60e0e76d8123ed55$exports = {};


var $f2c7ce238f066705$exports = {};


var $eb5fcdd9339254c0$exports = {};


var $121eb68aeebfc882$exports = {};


var $b52077f92925775a$exports = {};

$parcel$export($b52077f92925775a$exports, "toAddress", () => $b52077f92925775a$export$3483de426a571ace);
$parcel$export($b52077f92925775a$exports, "convertBits", () => $b52077f92925775a$export$79168ae09da5ac6b);
$parcel$export($b52077f92925775a$exports, "addressInfo", () => $b52077f92925775a$export$2f3c650e0d73b994);

function $b52077f92925775a$export$3483de426a571ace(hash, prefix) {
    return (0, $fpZC2$bech32.bech32m).encode(prefix, $b52077f92925775a$export$79168ae09da5ac6b(hash, 8, 5, true));
}
function $b52077f92925775a$export$2f3c650e0d73b994(address) {
    const { words: words , prefix: prefix  } = (0, $fpZC2$bech32.bech32m).decode(address);
    return {
        hash: $b52077f92925775a$export$79168ae09da5ac6b(Uint8Array.from(words), 5, 8, false),
        prefix: prefix
    };
}
function $b52077f92925775a$export$79168ae09da5ac6b(bytes, from, to, pad) {
    let accumulate = 0;
    let bits = 0;
    let maxv = (1 << to) - 1;
    let result = [];
    for (const value of bytes){
        const b = value & 0xff;
        if (b < 0 || b >> from > 0) throw new Error("Could not convert bits.");
        accumulate = accumulate << from | b;
        bits += from;
        while(bits >= to){
            bits -= to;
            result.push(accumulate >> bits & maxv);
        }
    }
    if (pad && bits > 0) result.push(accumulate << to - bits & maxv);
    else if (bits >= from || (accumulate << to - bits & maxv) != 0) throw new Error("Could not convert bits.");
    return Uint8Array.from(result);
}


var $5f95fe63e8980b33$exports = {};

$parcel$export($5f95fe63e8980b33$exports, "toCoinId", () => $5f95fe63e8980b33$export$3fec56fdf96ebecb);

var $e177a4f862f51cef$exports = {};

$parcel$export($e177a4f862f51cef$exports, "sanitizeHex", () => $e177a4f862f51cef$export$1cd910b238e58ea4);
$parcel$export($e177a4f862f51cef$exports, "formatHex", () => $e177a4f862f51cef$export$33cb1a0b2fba5a87);
function $e177a4f862f51cef$export$1cd910b238e58ea4(hex) {
    return hex.replace(/0x/i, "");
}
function $e177a4f862f51cef$export$33cb1a0b2fba5a87(hex) {
    return /^0x/i.test(hex) ? hex : `0x${hex}`;
}


function $5f95fe63e8980b33$export$3fec56fdf96ebecb(coin) {
    return (0, $fpZC2$chiabls.hash256)((0, $fpZC2$chiabls.concatBytes)((0, $fpZC2$chiabls.fromHex)((0, $e177a4f862f51cef$export$1cd910b238e58ea4)(coin.parent_coin_info)), (0, $fpZC2$chiabls.fromHex)((0, $e177a4f862f51cef$export$1cd910b238e58ea4)(coin.puzzle_hash)), (0, $fpZC2$chiabls.encodeInt)(coin.amount)));
}



$parcel$exportWildcard(module.exports, $c9adbe13b5bef015$exports);
$parcel$exportWildcard(module.exports, $d77b8e2ece17819c$exports);
$parcel$exportWildcard(module.exports, $fa39ccbcfd7ae7f1$exports);
$parcel$exportWildcard(module.exports, $670be6b4b89f768f$exports);
$parcel$exportWildcard(module.exports, $0173ec613b431074$exports);
$parcel$exportWildcard(module.exports, $043f1599d0393806$exports);
$parcel$exportWildcard(module.exports, $10a2a174d127c160$exports);
$parcel$exportWildcard(module.exports, $7234297413ebee48$exports);
$parcel$exportWildcard(module.exports, $cf11edfd5f0d971f$exports);
$parcel$exportWildcard(module.exports, $fe571803aa61466c$exports);
$parcel$exportWildcard(module.exports, $0a03bf2c86be8e1b$exports);
$parcel$exportWildcard(module.exports, $46d22c3d3d92ed29$exports);
$parcel$exportWildcard(module.exports, $ece4b6568aa7b803$exports);
$parcel$exportWildcard(module.exports, $d538b0dfcf012fe0$exports);
$parcel$exportWildcard(module.exports, $bb68f84c05a621e3$exports);
$parcel$exportWildcard(module.exports, $cb49cf0709c98c68$exports);
$parcel$exportWildcard(module.exports, $305d95833dd1d023$exports);
$parcel$exportWildcard(module.exports, $1268525a4b8e0e01$exports);
$parcel$exportWildcard(module.exports, $358edc65b317bb37$exports);
$parcel$exportWildcard(module.exports, $7e2e4bcdef253857$exports);
$parcel$exportWildcard(module.exports, $cbe256e5a99e5fe6$exports);
$parcel$exportWildcard(module.exports, $cb6b976e0ac661c2$exports);
$parcel$exportWildcard(module.exports, $7e170c62514a6894$exports);
$parcel$exportWildcard(module.exports, $638e6605c9cc86e1$exports);
$parcel$exportWildcard(module.exports, $5deed032471b2015$exports);
$parcel$exportWildcard(module.exports, $bf325bebb99236c7$exports);
$parcel$exportWildcard(module.exports, $933d7bb5ea47325a$exports);
$parcel$exportWildcard(module.exports, $aa1ce64064cb849d$exports);
$parcel$exportWildcard(module.exports, $2bca65a862d6af26$exports);
$parcel$exportWildcard(module.exports, $b32038b15901be82$exports);
$parcel$exportWildcard(module.exports, $60e0e76d8123ed55$exports);
$parcel$exportWildcard(module.exports, $f2c7ce238f066705$exports);
$parcel$exportWildcard(module.exports, $eb5fcdd9339254c0$exports);
$parcel$exportWildcard(module.exports, $121eb68aeebfc882$exports);
$parcel$exportWildcard(module.exports, $b52077f92925775a$exports);
$parcel$exportWildcard(module.exports, $5f95fe63e8980b33$exports);
$parcel$exportWildcard(module.exports, $e177a4f862f51cef$exports);


//# sourceMappingURL=index.js.map
